module.exports = __webpack_public_path__ + "h5/img/corrects-iconx.d7d3e077.png";